import React from 'react';

import Box from '@mui/material/Box';

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Snackbar, Stack, Tab, Tabs, TextField, TextareaAutosize, Tooltip, Typography } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";
import { MuiColorInput } from 'mui-color-input'
import { useTheme } from '@mui/material/styles';
import Editor from '@monaco-editor/react';
import { Clear, Restore, Save, SaveAlt } from '@mui/icons-material';
import Service from '../../../../util/Service';
import { useProfile } from '../../../common/useProfile';
import react from 'react';
import { IB } from './SettingPanel';

export default function ThemeSetting() {
    const theme = useTheme();
    const prof = useProfile();
    const navigate = useNavigate();
    const location = useLocation();

    const [palette, setPalette] = React.useState();//theme.palette);
    const [bkp, setBkp] = React.useState();
    const [campos, setCampos] = React.useState();
    const [js, setJs] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [msg, setMsg] = React.useState();
    const [value, setValue] = React.useState({
        cor: 'main',
        item: { main: '#000' }
    });
    const [tabVal, setTabVal] = React.useState(0);
    const [openDlg, setOpenDlg] = React.useState(false);
    const [cssCode, setCssCode] = react.useState('');

    React.useEffect(() => {
        init(theme.palette);
    }, [])

    const handleCloseDlg = () => {
        setOpenDlg(false);
    };

    function init(p) {
        const arr = [];
        let obj = {}
        for (let x in p) {

            if (typeof p[x] !== 'object') continue;
            if (x === 'grey') continue;
            if (x === 'action') continue;
            arr.push(x)
            obj[x] = p[x];
        }
        if (!bkp) {
            setBkp(JSON.stringify(obj))
        }
        setCampos(arr);
        setPalette(obj)
    }


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };
    const handleChangeCor = (newValue) => {
        const novo = { ...value };
        novo.item[novo.cor] = newValue;
        setValue(novo);
    }
    const handleChange = (e) => {
        // const key = e.target.name.split("_");
        // const p = { ...palette };
        // p[key[0]][key[1]] = e.target.value;
        // setPalette(p);
        const p = { ...palette };
        p[value.field][value.cor] = value.item[value.cor];
        setPalette(p);
        // const p = { ...palette };
        handleCloseDlg();
    }
    function handleEscolheCor(item, cor, field) {
        const v = {
            item: item,
            cor: cor,
            field: field,
        }
        setValue(v);
        setOpenDlg(true);
    }
    const montaCampos = (field, id) => {
        if (!palette) return;
        const obj = palette[field];
        const arr = [];
        for (let x in obj) {
            arr.push(x);
        }
        return (
            <React.Fragment>
                {arr.map((row, key) => (
                    // <TextField key={id + "_" + key} name={field + "_" + row} autoComplete="off" label={row} variant="standard"
                    //     sx={{ width: '20ch' }}
                    //     defaultValue={obj[row]}
                    //     onChange={handleChange}
                    // />
                    (<React.Fragment key={id + "_" + key} >
                        {montaComponenteCor(obj, row, field)}
                    </React.Fragment>)
                ))}
            </React.Fragment>
        );
    }
    const montaComponenteCor = (item, row, field) => {
        return (
            <Box component="section" sx={{
                ml: '20px', border: '1px solid grey', background: item[row], width: '200px',
                cursor: 'pointer', height: '60px'
            }} onClick={() => handleEscolheCor(item, row, field)}>
                <p>{row} - {item[row]}</p>
            </Box>
        )
    }
    const handleReset = () => {
        const o = JSON.parse(bkp);
        init(o);
        for (let x in o) {
            const item = o[x]
            for (let y in item) {
                const el = document.getElementsByName(x + "_" + y);
                if (el && el.length > 0) {
                    el[0].value = item[y];
                }
            }
        }
    }
    const handleClear = () => {
        Service.GET("/api/security/setting/removeTheme").then(r => {
            if (r.success) {
                window.location.reload(true);
            } else {
                setOpen(true);
                setMsg(r.msg);
            }
        }).catch(err => {
            if (err && err.status === 401) {
                localStorage.setItem("page", location.pathname);
                navigate("/login");
            }
        })
    }
    function handleCssChange(v){
        setCssCode(v);
        
    }
    function handleSaveJS(){
        console.log(js);
        const dado = {            
            code: js
        }
        Service.POST("/api/security/setting/js", dado).then(r => {
            console.log(r);
            if (r.success) {
                // window.location.reload(true);
            } else {
                setOpen(true);
                setMsg(r.msg);
            }
        })
    }
    function handleSaveCSS(){
        const dado = {            
            code: cssCode
        }
        Service.POST("/api/security/setting/css", dado).then(r => {
            console.log(r);
            if (r.success) {
                // window.location.reload(true);
            } else {
                setOpen(true);
                setMsg(r.msg);
            }
        })
    }
    function handleChangeTab(event, newValue) {
        setTabVal(newValue);
        console.log( newValue );
        if( newValue === 1 && cssCode.length === 0){
            Service.GET("/api/setting/css").then( r =>{
                console.log( r );
                if( r.success){
                    if( r.css && r.css.confs ){
                        console.log( '>....')
                        setCssCode( r.css.confs)
                    }
                }
            })
        }else if( newValue === 2 && js.length === 0){
            Service.GET("/api/setting/js").then( r =>{
                console.log( r );
                if( r.success){
                    if( r.js && r.js.confs ){
                        console.log( '>....')
                        setJs( r.js.confs)
                    }
                }
            })
        }
    }
    const handleSalvar = () => {
        Service.POST("/api/security/setting/theme", palette).then(r => {
            if (r.success) {
                window.location.reload(true);
            } else {
                setOpen(true);
                setMsg(r.msg);
            }
        }).catch(err => {
            console.error(err.status);
            if (err && err.status === 401) {
                localStorage.setItem("page", location.pathname);
                navigate("/login");
            }
        })
    }
    return (
        <div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabVal} onChange={handleChangeTab} aria-label="tabs setting theme" centered>
                    <Tab label="Paleta de cores" {...a11yProps(0)} />
                    <Tab label="Custom CSS" {...a11yProps(1)} />
                    <Tab label="CUstom JS" {...a11yProps(2)} />
                    {/* <Tab label="JavaScript" {...a11yProps(2)} /> */}
                </Tabs>
            </Box>
            <CustomTabPanel value={tabVal} index={0}>
                <Box sx={{ flexGrow: 1, mb: '25px' }}>
                    <div className='vr-float-dir'>
                        <Tooltip title="Limpar paleta de cores">
                            <IconButton color="primary" aria-label="limpar" onClick={handleClear}>
                                <Clear />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Reset paleta de cores">
                            <IconButton color="primary" aria-label="resetar" onClick={handleReset}>
                                <Restore />
                            </IconButton>
                        </Tooltip>
                        {prof.isOk && prof.temAcesso("portalAdm")}
                        <Tooltip title="Salvar paleta de cores">
                            <IconButton color="primary" aria-label="salvar" onClick={handleSalvar}>
                                <Save />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <Stack >
                        <Typography align='center' variant='h4'>Paleta de cores</Typography>
                        {campos && campos.map((row, id) => {
                            if (row === "primary" || row === "secondary" || row === "info" || row === "erro" ||
                                row === "warning" || row === 'background' || row === 'error' || row === 'success') {
                                return (
                                    <Stack direction="row" spacing={2} key={id} sx={{ ml: '25px' }}>
                                        <Typography
                                            variant="subtitle2"
                                            style={{ marginTop: "20px", width: "10ch" }}
                                        >
                                            {row}:
                                        </Typography>
                                        {montaCampos(row, id)}
                                    </Stack>)
                            } else return;
                        }
                        )}
                    </Stack>

                    <div style={{ marginTop: "10px" }}>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" color='primary'>primary</Button>
                            <Button variant="contained" color='secondary'>secondary</Button>
                            <Button variant="contained" color='error'>error</Button>
                            <Button variant="contained" color='info'>info</Button>
                            <Button variant="contained" color='success'>success</Button>
                            <Button variant="contained" color='warning'>warning</Button>
                        </Stack>
                    </div>
                    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                        <Alert
                            onClose={handleClose}
                            severity="success"
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {msg}
                        </Alert>
                    </Snackbar>

                    <Dialog open={openDlg} onClose={handleCloseDlg}>
                        <DialogTitle>COR</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Escolha a cor
                            </DialogContentText>

                            <MuiColorInput format="hex" value={value.item[value.cor]} onChange={handleChangeCor} />

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDlg}>Cancel</Button>
                            <Button onClick={handleChange}>
                                Modificar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </CustomTabPanel>
            <CustomTabPanel value={tabVal} index={1}>
                <Stack direction="row" spacing={0} >
                <Tooltip title="Salva Codigo">
                        <IB
                            variant='container'
                            onClick={handleSaveCSS}
                            size="small"
                        >
                            <Save />
                        </IB>
                    </Tooltip>
                </Stack>
                <Editor
                    height="75vh"
                    width= '100%'
                    defaultLanguage="css"
                    theme='vs-dark'
                    value={cssCode}
                    onChange={handleCssChange}
                    // onMount={handleEditorDidMount}
                    options={{
                        minimap: {
                            enabled: false,
                        },
                    }}
                />
            </CustomTabPanel>
            <CustomTabPanel value={tabVal} index={2}>
            <Stack direction="row" spacing={0} >
                <Tooltip title="Salva Codigo">
                        <IB
                            variant='container'
                            onClick={handleSaveJS}
                            size="small"
                        >
                            <Save />
                        </IB>
                    </Tooltip>
                </Stack>                
                {/* <TextareaAutosize
                    aria-label="minimum height"
                    minRows={3}                    
                    style={{ width: "100%", height:"700px" }}
                    value={js} onChange={ e => setJs(e.target.value)}
                    /> */}
                <Editor
                    height="75vh"
                    width= '100%'
                    defaultLanguage="javascript"
                    theme='vs-dark'
                    value={js}
                    onChange={ c => setJs(c) }
                    // onMount={handleEditorDidMount}
                    options={{
                        minimap: {
                            enabled: false,
                        },
                    }}
                />
            </CustomTabPanel>
        </div>
    );
}


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
